import {
  createAction,
  createAsyncThunk,
  createSlice
} from "@reduxjs/toolkit";
import { getBusyEventsAPIHelper } from "../helpers/calendarAPI";
import {
  applyJobAPIHelper,
  changeInterviewStatusAPIHelper,
  createJobAPIHelper,
  createMeetingAPIHelper,
  deleteJobAPIHelper,
  deleteNotificationsHelper,
  deleteRoundsAPIHelper,
  generateAISkillsAPIHelper,
  generateJobDescriptionAPIHelper,
  getAllApplicantsAPIHelper,
  getAllOfferLetterAPIHelper,
  getApplicantHistoryAPIHelper,
  getApplicantsAPIHelper,
  getApplicationStatusHistoryAPIHelper,
  getAppliedJobsAPIHelper,
  getAppliedJobsByIdAPIHelper,
  getCompanyEventsAPIHelper,
  getDocumentAPIHelper,
  getGlobalFilterAPIHelper,
  getGlobalSearchRedisCacheAPIHelper,
  getInterviewerEventsAPIHelper,
  getInterviewersAPIHelper,
  getInterviewRoundsAPIHelper,
  getJobAnalyticsAPIHelper,
  getJobNotificationsHelper,
  getOfferLetterAPIHelper,
  getOtherJobsAPIHelper,
  getPerticularJobAPIHelper,
  getPostedJobsAPIHelper,
  getRecruitrAPIHelper,
  getRoundsAPIHelper,
  getSingleApplicantAPIHelper,
  getSingleJobAPIHelper,
  getSingleOpenJobAPIHelper,
  getSinglePostedJobAPIHelper,
  getUserEventsAPIHelper,
  inviateGlobalCandidateAPIHelper,
  jobApplicationsAPIHelper,
  jobApplicationStatusAPIHelper,
  markAsreadNotificationsHelper,
  postAssignmentAPIHelper,
  postDocumentRequestAPIHelper,
  postDocumentResponseAPIHelper,
  postDocumentUploadAPIHelper,
  postInterviewRoundAPIHelper,
  postJobPreferencesAPIHelper,
  postJobSaveAPIHelper,
  respondOfferLetterHelperAPI,
  revokeOfferLetterHelperAPI,
  sendOfferLetterAPIHelper,
  updateInterviewRoundAPIHelper,
  updateJobAPIHelper,
  updateJobNotificationsHelper
} from "../helpers/JobsApi";


const initialState = {
  postedJobsData: {},
  openJobsData: {},
  savedJobsData: {},
  appliedJobsData: {},
  allApplicantsData: {},
  jobApplicantsData: {},
  singleOpenJob: {},
  singlePostedJob: {},
  singleAppliedJob: {},
  singleApplicant: {},
  allJobs: [],
  job: null,
  isRecruiter: false,
  interviewRounds: [],
  applicants: [],
  applicant: [],
  postedJobs: [],
  jobApplications: [],
  jobApplication: null,
  appliedJobs: [],
  filteredJobs: [],
  rounds: [],
  InterviewRounds: [],
  getJobMessages: [],
  getCallInvitation: [],
  UserEvent: [],
  RoundsUpdate: [],
  interviewers: [],
  InterviwerEvents: [],
  roundCreated: false,
  filteredOthersJobs: [],
  filteredCandidates: [],
  generatedSkills: [],
  OfferLetters: [],
  AllOfferLetters: [],
  generatedJobDescriptions: [],
  selectedCompany: {},
  interviewersbusyslots: {},
  selectedJobStatus: "",
  selectedJobDepartment: "",
  selectedAllApplicantsStatus: "",
  selectedJobApplicantsStatus: "",
  jobAnalytics: [],
  companyCalender: [],
  globalFilterCandidates: [],
  locationPlaces: [],
  getGlobalCandidates: [],
  savedParticularJob: [],
  applicationStatusHistory: [],
  professionalEvents: [],
  applicantHistory: [],
  singleJobDescription: [],
  documentsData:[],
  isLoading: false,
  viewMode: "grid",
  sortOrder: "descending",
  dateOrder: "descending",
  totalPages: 1,
  currentPage: 1,
  handledCallIds: new Set(),
  candidateUserRefId: null,
  currentJobApplicant: null,
  currentCandidate: null,
  selectedFilters: {
    dept_type: "",
    experience: "",
    edu_level: "",
    role: "",
    location: "",
    mode: "",
  },
};

export const getRecruiter = createAsyncThunk(
  "/jobs/isRecruiter",
  async (_, thunkAPI) => {
    try {
      const response = await getRecruitrAPIHelper();
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Get all job openings
// export const getAllJobs = createAsyncThunk(
//   "/jobs/get-jobs",
//   async (page = 0, thunkAPI) => {
//     try {
//       const response = await getAllJobAPIHelper(page);
//       return response;
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.message);
//     }
//   }
// );

export const getPostedJobs = createAsyncThunk(
  "/jobs/get-posted-jobs",
  async (params, thunkAPI) => {
    try {
      const response = await getPostedJobsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getOpenJobs = createAsyncThunk(
  "/jobs/get-open-jobs",
  async (params, thunkAPI) => {
    try {
      const response = await getOtherJobsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Get a particular job opening
export const getJob = createAsyncThunk(
  "/jobs/get-job",
  async (payload, thunkAPI) => {
    try {
      const response = await getPerticularJobAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Create a new job opening
export const createJob = createAsyncThunk(
  "/jobs/create-job",
  async (payload, thunkAPI) => {
    try {
      const response = await createJobAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Update an existing job opening
export const updateJob = createAsyncThunk(
  "/jobs/update-job",
  async (payload, thunkAPI) => {
    try {
      const response = await updateJobAPIHelper(payload);
      // console.log("updateJobAPIHelper", response);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Delete a job opening
export const deleteJob = createAsyncThunk(
  "/jobs/delete-job",
  async (payload, thunkAPI) => {
    try {
      const response = await deleteJobAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const setJobViewMode = createAction("jobs/setViewMode");
export const sortJobs = createAction("jobs/sortJobs");

export const filterJobs = createAction("jobs/filterJobs");
export const FilterOtherJobs = createAction("jobs/OtherJobs");

export const setCurrentCandidate = createAction("jobs/setCurrentCandidate");

export const updateCallHandledStatus = createAction("jobs/updateCallHandledStatus");

// Apply job
export const applyJob = createAsyncThunk(
  "jobs/apply-job",
  async (payload, thunkAPI) => {
    try {
      const response = await applyJobAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Change job application status
export const changeJobApplicationStatus = createAsyncThunk(
  "jobs/application-status",
  async (payload, thunkAPI) => {
    try {
      const response = await jobApplicationStatusAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Get job applications
export const getJobApplications = createAsyncThunk(
  "jobs/applications",
  async (_, thunkAPI) => {
    try {
      const response = await jobApplicationsAPIHelper();
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Get applied jobs
export const getAppliedJobs = createAsyncThunk(
  "jobs/applied-jobs",
  async (params, thunkAPI) => {
    try {
      const response = await getAppliedJobsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Get applied jobs
export const getAppliedJobById = createAsyncThunk(
  "jobs/applied-job-by-Id",
  async (payload, thunkAPI) => {
    try {
      const response = await getAppliedJobsByIdAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Get applicants for a job
export const getApplicants = createAsyncThunk(
  "/jobs/get-applicants",
  async (payload, thunkAPI) => {
    try {
      const response = await getApplicantsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getSingleApplicantById = createAsyncThunk(
  "/jobs/get-single-applicants-Id",
  async (payload, thunkAPI) => {
    try {
      const response = await getSingleApplicantAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getSingleOpenJob = createAsyncThunk(
  "/jobs/get-single-open-job",
  async (params, thunkAPI) => {
    try {
      const response = await getSingleOpenJobAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getSinglePostedJob = createAsyncThunk(
  "/jobs/get-single-posted-job",
  async (params, thunkAPI) => {
    try {
      const response = await getSinglePostedJobAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postJobPreferences = createAsyncThunk(
  "/userprofile/job-preferences",
  async (payload, thunkAPI) => {
    try {
      const response = await postJobPreferencesAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const generateAISkills = createAsyncThunk(
  "jobs/generateAISkills",
  async (payload, thunkAPI) => {
    try {
      const response = await generateAISkillsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// jobsSlice.js
export const generateJobDescription = createAsyncThunk(
  "jobs/generateJobDescription",
  async (payload, thunkAPI) => {
    try {
      const response = await generateJobDescriptionAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getJobAnalytics = createAsyncThunk(
  "/jobs/analytics",
  async (params, thunkAPI) => {
    try {
      const response = await getJobAnalyticsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getCandidates = createAsyncThunk(
  "/job/all-applicants",
  async (payload, thunkAPI) => {
    try {
      const response = await getAllApplicantsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getGlobalCandidates = createAsyncThunk(
  "/job/all-global-applicants",
  async (payload, thunkAPI) => {
    try {
      const response = await getGlobalSearchRedisCacheAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const saveParticularJob = createAsyncThunk(
  "/job/job-save",
  async (payload, thunkAPI) => {
    try {
      const response = await postJobSaveAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getApplicationStatusHistory = createAsyncThunk(
  "/job/application-history",
  async (payload, thunkAPI) => {
    try {
      const response = await getApplicationStatusHistoryAPIHelper(payload);
      // console.log("response", response);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getApplicantHistory = createAsyncThunk(
  "/job/applicant-history",
  async (_, thunkAPI) => {
    try {
      const response = await getApplicantHistoryAPIHelper();
      // console.log("response", response);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// export const getInterviewRounds = createAsyncThunk(
//   '/job/interview-rounds',
//   async (payload, thunkAPI) => {
//     try {
//       const response = await getRoundsAPIHelper(payload);
//       console.log("response", response)
//       return response;
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.message);
//     }
//   },
// );

export const getRounds = createAsyncThunk(
  "jobs/getRounds",
  async (payload, thunkAPI) => {
    try {
      const response = await getRoundsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getInterviewRounds = createAsyncThunk(
  "jobs/getInterviewRounds",
  async (payload, thunkAPI) => {
    try {
      const response = await getInterviewRoundsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postInterviewRound = createAsyncThunk(
  "jobs/postInterviewRound",
  async (payload, thunkAPI) => {
    try {
      const response = await postInterviewRoundAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getInterviewers = createAsyncThunk(
  "jobs/getInterviewers",
  async (params, thunkAPI) => {
    try {
      const response = await getInterviewersAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Change job Interview application status
export const changeInterviewStatus = createAsyncThunk(
  "jobs/interview-status",
  async (payload, thunkAPI) => {
    try {
      const response = await changeInterviewStatusAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Get getComapnyCalender for a jobss
export const getComapnyCalender = createAsyncThunk(
  "/jobs/get-comapny-calender",
  async (params, thunkAPI) => {
    try {
      const response = await getCompanyEventsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getUserEvents = createAsyncThunk(
  "/jobs/get-user-events",
  async (_, thunkAPI) => {
    try {
      const response = await getUserEventsAPIHelper();
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateInterviewRound = createAsyncThunk(
  "jobs/updateInterviewRound",
  async (payload, thunkAPI) => {
    try {
      const response = await updateInterviewRoundAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteRond = createAsyncThunk(
  "/jobs/delete-round",
  async (payload, thunkAPI) => {
    try {
      const response = await deleteRoundsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postInviteforGlobal = createAsyncThunk(
  "jobs/postInvite-for-global",
  async (payload, thunkAPI) => {
    try {
      const response = await inviateGlobalCandidateAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getFilterForGlobal = createAsyncThunk(
  "jobs/get-Filter-Global",
  async (payload, thunkAPI) => {
    try {
      const response = await getGlobalFilterAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getInterviwerEvents = createAsyncThunk(
  "jobs/get-interviwer-Events",
  async (payload, thunkAPI) => {
    try {
      const response = await getInterviewerEventsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateAssignment = createAsyncThunk(
  "jobs/update-assignment",
  async (payload, thunkAPI) => {
    try {
      const response = await postAssignmentAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postProfessionalEvent = createAsyncThunk(
  "jobs/post-professional-calender",
  async (payload, thunkAPI) => {
    try {
      const response = await createMeetingAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postOfferLetter = createAsyncThunk(
  "jobs/post-offer-letter",
  async (payload, thunkAPI) => {
    try {
      const response = await sendOfferLetterAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getOfferLetter = createAsyncThunk(
  "jobs/get-offer-letter",
  async (payload, thunkAPI) => {
    try {
      const response = await getOfferLetterAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const revokeTheoffer = createAsyncThunk(
  "jobs/Revoke-offer-letter",
  async (payload, thunkAPI) => {
    try {
      const response = await revokeOfferLetterHelperAPI(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const respondTheoffer = createAsyncThunk(
  "jobs/Respond-offer-letter",
  async (payload, thunkAPI) => {
    try {
      const response = await respondOfferLetterHelperAPI(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getAllOfferLetter = createAsyncThunk(
  "jobs/get-All-offer-letter",
  async (payload, thunkAPI) => {
    try {
      const response = await getAllOfferLetterAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getJobNotifications = createAsyncThunk(
  "/jobs/get-job-notifications",
  async (_, thunkAPI) => {
    try {
      const response = await getJobNotificationsHelper();
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateJobNotifications = createAsyncThunk(
  "jobs/update-job-notifications",
  async (payload, thunkAPI) => {
    try {
      const response = await updateJobNotificationsHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const markasReadJobNotifications = createAsyncThunk(
  "jobs/mark-as-read-notifications",
  async (_, thunkAPI) => {
    try {
      const response = await markAsreadNotificationsHelper();
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteJobNotifications = createAsyncThunk(
  "jobs/delete-all-job-notifications",
  async (payload, thunkAPI) => {

    try {
      const response = await deleteNotificationsHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const interviewBusyShedule = createAsyncThunk(
  "jobs/interview-busy-shedule",
  async (params, thunkAPI) => {
    try {
      const response = await getBusyEventsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getSingleJobDesc = createAsyncThunk(
  "jobs/get-single-job-description",
  async (id, thunkAPI) => {
    try {
      const response = await getSingleJobAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postDocumentRequest = createAsyncThunk(
  'jobs/document-request',
  async (payload, thunkAPI) => {
    try {
      const response = await postDocumentRequestAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const postDocumentUpload = createAsyncThunk(
  '/job/document-upload',
  async (payload, thunkAPI) => {
    try {
      const response = await postDocumentUploadAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const postDocumenResponse = createAsyncThunk(
  '/job/document-response',
  async (payload, thunkAPI) => {
    try {
      const response = await postDocumentResponseAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const getDocuments = createAsyncThunk(
  '/job/documents-view',
  async (id, thunkAPI) => {
    try {
      const response = await getDocumentAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);




const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    setCurrentJobApplicantId: (state, action) => {
      state.currentJobApplicant = action.payload;
    },
    setCurrentCandidate: (state, action) => {
      state.currentCandidate = action.payload;
    },
    setCurrentUserRefId: (state, action) => {
      state.candidateUserRefId = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedCompany: (state, action) => {
      // console.log("setSelectedCompany", action.payload);
      state.selectedCompany = action.payload;
    },
    setSelectedJobStatus: (state, action) => {
      state.selectedJobStatus = action.payload;
    },
    setSelectedJobDepartment: (state, action) => {
      state.selectedJobDepartment = action.payload;
    },
    setSelectedApplicantStatus: (state, action) => {
      state.selectedAllApplicantsStatus = action.payload;
    },
    setSelectedJobApplicantStatus: (state, action) => {
      state.selectedJobApplicantsStatus = action.payload;
    },
    updateCallHandledStatus: (state, action) => {
      const { callId } = action.payload;
      state.handledCallIds.add(callId);
      state.getCallInvitation = state.getCallInvitation.map(call =>
        call.id === callId
          ? { ...call, handled: true }
          : call
      );
    },
  },
  extraReducers: (builder) => {
    // Recruiter check (Assumed)
    builder
      .addCase(getRecruiter.fulfilled, (state, action) => {
        // console.log("getRecruiterFullfilled", JSON.stringify(action));
        state.isRecruiter = action.payload?.data;
      })
      .addCase(getRecruiter.rejected, (state, action) => {
        console.error("Error details:", action.error.message);
      })


      // Get all jobs
      // builder
      //   .addCase(getAllJobs.fulfilled, (state, action) => {
      //     if (action?.payload?.data?.jobs == undefined) {
      //       state.allJobs = action.payload?.data?.open_jobs;
      //       state.postedJobs = action.payload?.data?.posted_jobs;
      //     } else {
      //       state.allJobs = action.payload.data?.jobs;
      //       state.postedJobs = [];
      //     }
      //     // Add pagination data
      //   })

      .addCase(getJobNotifications.fulfilled, (state, action) => {
        // Combine notification and call handling logic
        const existingCalls = state.getCallInvitation || [];
        const newCalls = action?.payload?.agoraVideoCallNotification || [];

        const updatedCalls = newCalls.map(newCall => {
          const existingCall = existingCalls.find(call => call.id === newCall.id);
          return existingCall?.handled
            ? { ...newCall, handled: true }
            : { ...newCall, handled: false };
        });

        state.getJobMessages = action?.payload?.jobNotifications || [];
        state.getCallInvitation = updatedCalls;
      })
      .addCase(getJobNotifications.rejected, (state, action) => {
        // console.log("getJobRejected", JSON.stringify(action));
      })

      .addCase(getPostedJobs.fulfilled, (state, action) => {
        // state.postedJobsData = action?.payload?.data;
        // state.postedJobs = action?.payload?.data?.posted_jobs || [];
        if (action?.meta?.arg?.page) {
          state.postedJobsData = {
            ...state.postedJobsData,
            pagination: action.payload?.data?.pagination,
            posted_jobs: action.payload?.data?.posted_jobs,
          };
        } else {
          state.postedJobsData = action.payload?.data;
        }
      })
      .addCase(getPostedJobs.rejected, (state, action) => {
        // console.log("getJobRejected", JSON.stringify(action));
      })

      .addCase(getOpenJobs.fulfilled, (state, action) => {
        if (action?.meta?.arg?.page) {
          state.allJobs = {
            ...state.allJobs,
            pagination: action.payload?.data?.pagination,
            open_jobs: action.payload?.data?.open_jobs,
          };
        } else {
          state.allJobs = action.payload?.data;
        }
      })

      .addCase(getOpenJobs.rejected, (state, action) => {
        // console.log("getJobRejected", JSON.stringify(action));
      })

      // Get a particular job

      .addCase(getJob.fulfilled, (state, action) => {
        state.job = action.payload?.data;
        // console.log("getJobFulfilled", JSON.stringify(action));
      })
      .addCase(getJob.rejected, (state, action) => {
        // console.log("getJobRejected", JSON.stringify(action));
      })

      .addCase(getSinglePostedJob.fulfilled, (state, action) => {
        state.singlePostedJob = action?.payload?.data;
        // console.log("getsinglePostedJobFulfilled", JSON.stringify(action));
      })
      .addCase(getSinglePostedJob.rejected, (state, action) => {
        // console.log("getsinglePostedJobFulfilled", JSON.stringify(action));
      })

      .addCase(getSingleOpenJob.fulfilled, (state, action) => {
        state.singleOpenJob = action?.payload?.data;
        // console.log("getsingleOpenFulfilled", JSON.stringify(action));
      })
      .addCase(getSingleOpenJob.rejected, (state, action) => {
        // console.log("getsingleOpenRejected", JSON.stringify(action));
      })
      .addCase(getAppliedJobById.fulfilled, (state, action) => {
        state.singleAppliedJob = action?.payload?.data?.job;
        // console.log("getsingleAppliedJobFulfilled", JSON.stringify(action));
      })
      .addCase(getAppliedJobById.rejected, (state, action) => {
        // console.log("getsingleAppliedJobRejected", JSON.stringify(action));
      })

      .addCase(getCandidates.fulfilled, (state, action) => {
        state.allApplicantsData = action.payload?.data || [];
        state.applicants = action.payload?.data;
        // console.log("hello1", action.payload?.data);
        // state.totalPages = action.payload?.data?.totalPages || 1;
        // state.currentPage = action.payload?.data?.currentPage || 0;
      })
      .addCase(getCandidates.rejected, (state, action) => {
        // console.log("getJobRejected", JSON.stringify(action));
      })
      .addCase(interviewBusyShedule.fulfilled, (state, action) => {
        state.interviewersbusyslots = action.payload?.data;
        // console.log("interviewersbusyslots", JSON.stringify(action));
      })
      .addCase(interviewBusyShedule.rejected, (state, action) => {
        // console.log("interviewersbusyslots", JSON.stringify(action));
      })

      // Create a new job

      .addCase(createJob.fulfilled, (state, action) => {
        console.log("createJobFulfilled", JSON.stringify(action));
      })
      .addCase(createJob.rejected, (state, action) => {
        console.log("createJobRejected", JSON.stringify(action));
      })

      // Create a new job

      .addCase(revokeTheoffer.fulfilled, (state, action) => {
        console.log("revokeTheofferFulfilled", JSON.stringify(action));
      })
      .addCase(revokeTheoffer.rejected, (state, action) => {
        console.log("revokeTheofferRejected", JSON.stringify(action));
      })

      .addCase(updateJobNotifications.fulfilled, (state, action) => {
        console.log("updateJobNotifications", JSON.stringify(action));
      })
      .addCase(updateJobNotifications.rejected, (state, action) => {
        console.log("updateJobNotifications", JSON.stringify(action));
      })
      .addCase(markasReadJobNotifications.fulfilled, (state, action) => {
        console.log("markasReadJobNotifications", JSON.stringify(action));
      })
      .addCase(markasReadJobNotifications.rejected, (state, action) => {
        console.log("markasReadJobNotifications", JSON.stringify(action));
      })
      .addCase(deleteJobNotifications.fulfilled, (state, action) => {
        console.log("deleteJobNotifications", JSON.stringify(action));
      })
      .addCase(deleteJobNotifications.rejected, (state, action) => {
        console.log("deleteJobNotifications", JSON.stringify(action));
      })

      // Create a new job

      .addCase(respondTheoffer.fulfilled, (state, action) => {
        console.log("respondTheofferFulfilled", JSON.stringify(action));
      })
      .addCase(respondTheoffer.rejected, (state, action) => {
        console.log("respondTheofferRejected", JSON.stringify(action));
      })

      .addCase(postInviteforGlobal.fulfilled, (state, action) => {
        console.log("postInviteforGlobal", JSON.stringify(action));
      })
      .addCase(postInviteforGlobal.rejected, (state, action) => {
        console.log("postInviteforGlobal", JSON.stringify(action));
      })

      // Create a new job

      .addCase(postProfessionalEvent.fulfilled, (state, action) => {
        console.log("postProfessionalEvent", JSON.stringify(action));
      })
      .addCase(postProfessionalEvent.rejected, (state, action) => {
        console.log("postProfessionalEvent", JSON.stringify(action));
      })

      // Update an existing job

      .addCase(updateJob.fulfilled, (state, action) => {
        // Update the job in state
        if (action.payload?.statusCode === 200) {
          state.job = action.payload?.data?.job;

          // Also update in postedJobs array if exists
          const jobId = action.payload?.data?.job?.id;
          const index = state.postedJobs?.findIndex((job) => job.id === jobId);
          if (index !== -1) {
            state.postedJobs[index] = action.payload?.data?.job;
          }
        }
        console.log("updateJobFulfilled", JSON.stringify(action));
      })
      .addCase(updateJob.rejected, (state, action) => {
        console.log("updateJobRejected", JSON.stringify(action));
      })

      .addCase(deleteRond.fulfilled, (state, action) => {
        state.rounds = state.rounds.filter(
          (round) => round?.round_code !== action.meta.arg
        );
      })

      .addCase(deleteRond.rejected, (state, action) => {
        console.log("deleteJobRejected", JSON.stringify(action));
      })

      // Delete a job

      .addCase(deleteJob.fulfilled, (state, action) => {
        state.postedJobs = state.postedJobs.filter(
          (job) => job?.id !== action.meta.arg
        );
      })

      .addCase(deleteJob.rejected, (state, action) => {
        console.log("deleteJobRejected", JSON.stringify(action));
      })

      // Delete a job

      .addCase(getInterviwerEvents.fulfilled, (state, action) => {
        state.InterviwerEvents = action.payload?.data?.events;
      })

      .addCase(getInterviwerEvents.rejected, (state, action) => {
        console.log("deleteJobRejected", JSON.stringify(action));
      })

      // Apply for a job

      .addCase(applyJob.fulfilled, (state, action) => {
        console.log("applyJobFulfilled", JSON.stringify(action));
      })
      .addCase(applyJob.rejected, (state, action) => {
        console.log("applyJobRejected", JSON.stringify(action));
      })

      // Get applicants for a job

      .addCase(getApplicants.fulfilled, (state, action) => {
        state.jobApplicantsData = action.payload?.data;
        state.applicants = action.payload?.data?.applicants;
        console.log("hllo2", action.payload?.data?.applicants);
      })
      .addCase(getApplicants.rejected, (state, action) => {
        console.log("getApplicantsRejected", JSON.stringify(action));
      })

      .addCase(getComapnyCalender.fulfilled, (state, action) => {
        state.companyCalender = action.payload?.data;
        console.log("getCompanyCalender", action.payload);
      })
      .addCase(getComapnyCalender.rejected, (state, action) => {
        console.log("getApplicantsRejected", JSON.stringify(action));
      })
      .addCase(getSingleApplicantById.fulfilled, (state, action) => {
        state.singleApplicant = action.payload?.data;
        console.log("getSingleApplicantFulfilled", action.payload?.data);
      })
      .addCase(getSingleApplicantById.rejected, (state, action) => {
        console.log("getSingleApplicantRejected", JSON.stringify(action));
      })

      .addCase(getOfferLetter.fulfilled, (state, action) => {
        state.OfferLetters = action?.payload?.data?.offerLetter || [];
        console.log("getOfferLetter success:", action);
      })
      .addCase(getOfferLetter.rejected, (state, action) => {
        state.OfferLetters = [];
        console.error(
          "getOfferLetter failed:",
          action?.error?.message || action
        );
      })

      .addCase(getAllOfferLetter.fulfilled, (state, action) => {
        state.AllOfferLetters = action?.payload?.data || {};
        console.log("getOfferLetter success:", action);
      })
      .addCase(getAllOfferLetter.rejected, (state, action) => {
        state.AllOfferLetters = [];
        console.error(
          "getOfferLetter failed:",
          action?.error?.message || action
        );
      })

      .addCase(getFilterForGlobal.fulfilled, (state, action) => {
        state.globalFilterCandidates = action.payload;
        console.log("getFilterForGlobalFulfilled", action);
      })
      .addCase(getFilterForGlobal.rejected, (state, action) => {
        state.globalFilterCandidates = action.payload?.data;
        console.log("getFilterForGlobalRejected", JSON.stringify(action));
      })

      // Get Rounds
      .addCase(getRounds.fulfilled, (state, action) => {
        state.rounds = action.payload?.data || [];
        console.log("getRounds fulfilled:", action.payload);
      })
      .addCase(getRounds.rejected, (state, action) => {
        console.error("getRounds failed:", action.error.message);
        state.rounds = [];
      })
      // Get Rounds
      .addCase(updateInterviewRound.fulfilled, (state, action) => {
        console.log("updateInterviewRound fulfilled:", action.payload);
      })
      .addCase(updateInterviewRound.rejected, (state, action) => {
        console.error("updateInterviewRound failed:", action.error.message);
      })

      // Get Rounds
      .addCase(updateAssignment.fulfilled, (state, action) => {
        console.log("updateAssignment fulfilled:", action.payload);
      })
      .addCase(updateAssignment.rejected, (state, action) => {
        console.error("updateAssignment failed:", action.error.message);
      })

      // Get Interview Rounds
      .addCase(getInterviewRounds.fulfilled, (state, action) => {
        state.interviewRounds = action.payload?.data || [];
        console.log("getInterviewRounds fulfilled:", action.payload);
      })
      .addCase(getInterviewRounds.rejected, (state, action) => {
        console.error("getInterviewRounds failed:", action.error.message);
        state.interviewRounds = [];
      })

      // Post Interview Round
      .addCase(postInterviewRound.fulfilled, (state, action) => {
        state.roundCreated = true;
        console.log("postInterviewRound fulfilled:", action.payload);
      })
      .addCase(postInterviewRound.rejected, (state, action) => {
        console.error("postInterviewRound failed:", action.error.message);
        state.roundCreated = false;
      })

      // Post offer letter
      .addCase(postOfferLetter.fulfilled, (state, action) => {
        // state.roundCreated = true;
        console.log("postInterviewRound fulfilled:", action.payload);
      })
      .addCase(postOfferLetter.rejected, (state, action) => {
        console.error("postInterviewRound failed:", action.error.message);
        // state.roundCreated = false;
      })

      // Get Interviewers
      .addCase(getInterviewers.fulfilled, (state, action) => {
        state.interviewers = action.payload?.data || [];
        console.log("getInterviewers fulfilled:", action.payload);
      })
      .addCase(getInterviewers.rejected, (state, action) => {
        console.error("getInterviewers failed:", action.error.message);
        state.interviewers = [];
      })

      // Change job application status
      .addCase(changeJobApplicationStatus.fulfilled, (state, action) => {
        console.log(
          "changeJobApplicationStatusFulfilled",
          JSON.stringify(action)
        );
      })
      .addCase(changeJobApplicationStatus.rejected, (state, action) => {
        console.log(
          "changeJobApplicationStatusRejected",
          JSON.stringify(action)
        );
      })
      // Change job application status
      .addCase(changeInterviewStatus.fulfilled, (state, action) => {
        state.RoundsUpdate = action.payload?.data;
        console.log("changeInterviewStatusFulfilled", JSON.stringify(action));
      })

      .addCase(changeInterviewStatus.rejected, (state, action) => {
        console.log("changeInterviewStatusRejected", JSON.stringify(action));
        state.RoundsUpdate = [];
      })

      // Get job applications
      .addCase(getJobApplications.fulfilled, (state, action) => {
        state.jobApplications = action.payload?.data?.applications;
        console.log(
          "getJobApplicationsFulfilled",
          action.payload?.data?.applications
        );
      })
      .addCase(getJobApplications.rejected, (state, action) => {
        console.error("Error details:", action.error.message);
      })

      // Get applied jobs
      .addCase(getAppliedJobs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAppliedJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.appliedJobs = action?.payload?.data;
        if (action?.meta?.arg?.page) {
          state.appliedJobs = {
            ...state.appliedJobs,
            pagination: action.payload?.data?.pagination,
            appliedJobs: action.payload?.data?.appliedJobs,
          };
        } else {
          state.appliedJobs = action.payload?.data;
        }
        // state.totalPages = action?.payload?.data?.pagination?.totalPages;
        // // Convert 0-based API page to 1-based for the component
        // state.currentPage = action?.meta?.arg + 1;
      })
      .addCase(getAppliedJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      //applicanthistrory
      .addCase(getApplicationStatusHistory.fulfilled, (state, action) => {
        state.applicationStatusHistory = action?.payload?.data;
        // console.log("action getApplicationStatusHistory", action?.payload);
      })
      .addCase(getApplicationStatusHistory.rejected, (state, action) => {
        console.error(
          "action getApplicationStatusHistory",
          action.error.message
        );
      })

      //applicants-status-applicant page
      .addCase(getApplicantHistory.fulfilled, (state, action) => {
        state.applicantHistory = action?.payload?.data;
        // console.log("action getApplicationStatusHistory", action?.payload);
      })
      .addCase(getApplicantHistory.rejected, (state, action) => {
        console.error(
          "action getApplicationStatusHistory",
          action.error.message
        );
      })

      .addCase(sortJobs, (state, action) => {
        const { type, order } = action.payload;
        state.postedJobs = [...state.postedJobs].sort((a, b) => {
          if (type === "title") {
            return order === "asc"
              ? a.title.localeCompare(b.title)
              : b.title.localeCompare(a.title);
          }
          if (type === "date") {
            return order === "asc"
              ? new Date(a.date_posted) - new Date(b.date_posted)
              : new Date(b.date_posted) - new Date(a.date_posted);
          }
          return 0;
        });
      })

      .addCase(filterJobs, (state, action) => {
        const { search, ...filters } = action.payload;

        // Get active filters
        const activeFilters = Object.entries(filters).filter(
          ([_, value]) => value !== ""
        );

        // Apply search and filters
        state.filteredJobs = state.postedJobsData?.posted_jobs?.filter(
          (job) => {
            // Search check
            const matchesSearch =
              !search ||
              job.role?.toLowerCase().includes(search.toLowerCase()) ||
              job.company_name?.toLowerCase().includes(search.toLowerCase()) ||
              job.location?.toLowerCase().includes(search.toLowerCase());

            // Filter check
            const matchesFilters =
              activeFilters.length === 0 ||
              activeFilters.every(([key, value]) => {
                const jobValue = job[key]?.toString().toLowerCase().trim();
                const filterValue = value.toString().toLowerCase().trim();
                return jobValue === filterValue;
              });

            return matchesSearch && matchesFilters;
          }
        );
      })
      .addCase(setJobViewMode, (state, action) => {
        state.viewMode = action.payload;
      })

      .addCase(generateAISkills.fulfilled, (state, action) => {
        if (action.payload.status === "SUCCESS") {
          state.generatedSkills = action.payload?.data?.topSkills;
        }
      })
      .addCase(generateAISkills.rejected, (state, action) => {
        console.error("Skills generation failed:", action.error.message);
      })

      // Inside jobsSlice's extraReducers
      .addCase(generateJobDescription.fulfilled, (state, action) => {
        if (action.payload.status === "SUCCESS") {
          state.generatedJobDescriptions = action.payload.data; // Store the generated JD
        }
      })

      // Error handling (optional)
      .addCase(generateJobDescription.rejected, (state, action) => {
        console.error("Generation failed:", action.error.message);
      })

      .addCase(saveParticularJob.fulfilled, (state, action) => {
        state.savedParticularJob = action?.payload;
        // console.log("action saveParticularJob", action.payload);
      })
      .addCase(saveParticularJob.rejected, (state, action) => {
        console.error("action saveParticularJob", action.error.message);
      })

      .addCase(FilterOtherJobs, (state, action) => {
        const { search, ...filters } = action.payload;

        // Get active filters
        const activeFilters = Object.entries(filters).filter(
          ([_, value]) => value !== ""
        );

        // Apply search and filters
        state.filteredOthersJobs = state?.allJobs?.filter((job) => {
          // Search check
          const matchesSearch =
            !search ||
            job.role?.toLowerCase().includes(search.toLowerCase()) ||
            job.company_name?.toLowerCase().includes(search.toLowerCase()) ||
            job.location?.toLowerCase().includes(search.toLowerCase());

          // Filter check
          const matchesFilters =
            activeFilters.length === 0 ||
            activeFilters.every(([key, value]) => {
              const jobValue = job[key]?.toString().toLowerCase().trim();
              const filterValue = value.toString().toLowerCase().trim();
              return jobValue === filterValue;
            });

          return matchesSearch && matchesFilters;
        });
      })

      .addCase(postJobPreferences.fulfilled, (state, action) => {
        // console.log("action postJobPreferences");
      })
      .addCase(postJobPreferences.rejected, (state, action) => {
        console.error("action postJobPreferences", action.error.message);
      })

      .addCase(getJobAnalytics.fulfilled, (state, action) => {
        state.jobAnalytics = action.payload;
        // console.log("action getJobAnalytics");
      })
      .addCase(getJobAnalytics.rejected, (state, action) => {
        console.error("action getJobAnalytics", action.error.message);
      })

      .addCase(getGlobalCandidates.fulfilled, (state, action) => {
        state.getGlobalCandidates = action.payload;
        // console.log("action getGlobalCandidates", action.payload);
      })
      .addCase(getGlobalCandidates.rejected, (state, action) => {
        console.error("action getGlobalCandidates", action.error.message);
      })

      .addCase(getUserEvents.fulfilled, (state, action) => {
        state.UserEvent = action?.payload?.data?.events;
        // console.log("getUserEvents", action);
      })
      .addCase(getUserEvents.rejected, (state, action) => {
        state.UserEvent = action.payload?.data;
        // console.log("getUserEvents", JSON.stringify(action));
      })

      .addCase(getSingleJobDesc.fulfilled, (state, action) => {
        state.singleJobDescription = action?.payload?.data;

      })
      .addCase(getSingleJobDesc.rejected, (state, action) => {
        state.singleJobDescription = action.payload?.data;

      })
      .addCase(postDocumentRequest.fulfilled, (state, action) => {
        // console.log('action postDocumentRequest fullfilled');
      })
      .addCase(postDocumentRequest.rejected, (state, action) => {
        console.error(
          'action postDocumentRequest rejected ',
          action.error.message,
        );
      })
            .addCase(postDocumentUpload.fulfilled, (state, action) => {
        // console.log('action postDocumentUpload fullfilled');
      })
      .addCase(postDocumentUpload.rejected, (state, action) => {
        console.error(
          'action postDocumentUpload rejected ',
          action.error.message,
        );
      })
      .addCase(postDocumenResponse.fulfilled, (state, action) => {
        // console.log('action postDocumenResponse fullfilled');
      })
      .addCase(postDocumenResponse.rejected, (state, action) => {
        console.error(
          'action postDocumenResponse rejected ',
          action.error.message,
        );
      })
      .addCase(getDocuments.fulfilled, (state, action) => {
        state.documentsData = action?.payload?.data;
        // console.log('action getDocuments fullfilled');
      })
      

      // Generic loading state handler
      .addMatcher(
        (action) => action.type.endsWith("/pending"),
        (state) => {
          state.isLoading = true;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith("/fulfilled"),
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state) => {
          state.isLoading = false;
        }
      )

  },
});

// export const {onClickCamera, onClickCircleMenu} = cameraSlice.actions;

export const {
  setCurrentJobApplicantId,
  setCurrentUserRefId,
  setCurrentPage,
  setSelectedCompany,
  setSelectedJobStatus,
  setSelectedJobDepartment,
  setSelectedApplicantStatus,
  setSelectedJobApplicantStatus
} = jobsSlice.actions;
export default jobsSlice.reducer;
